var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39 39",
    style: {
      enableBackground: "new 0 0 39 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#030201;stroke-width:0.6463;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.7,8.9C4.4,7,10.8,0.7,19.7,1.1c2.4,0.1,8.9,0.2,13.9,6.7c1.2,1.5,5,6.5,4.6,12.8 c-0.5,9.8-10.5,17.1-18.9,17.6C13.5,38.5,6.5,35.6,2.8,29c-0.8-1.5-2.4-4.4-2.3-8.4C0.7,15.1,3.9,9.9,8.9,7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1,28.3c-2.9,0-5.9-1.4-8.9-4c-1.4-1.2-2.6-2.5-3.6-3.9c-0.1-0.1-0.1-0.3,0-0.4c1.1-1.4,2.3-2.8,3.6-3.9c3-2.6,6-4,8.9-4 s5.9,1.4,8.9,4c1.4,1.2,2.6,2.5,3.6,3.9c0.1,0.1,0.1,0.3,0,0.4c-1.1,1.4-2.3,2.8-3.6,3.9C25,27,22,28.3,19.1,28.3z M7.3,20.2 c0.9,1.2,5.9,7.4,11.8,7.4s10.9-6.2,11.8-7.4C30,19,25,12.9,19.1,12.9S8.2,19,7.3,20.2L7.3,20.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1,24.1c-1,0-2-0.4-2.8-1.1c-0.7-0.7-1.2-1.7-1.2-2.7c0-1,0.4-2,1.1-2.8c0.7-0.7,1.7-1.1,2.7-1.2c1,0,2,0.4,2.7,1.1 c0.7,0.7,1.1,1.7,1.1,2.7c0,1-0.4,2-1.1,2.7C21.1,23.7,20.1,24.1,19.1,24.1L19.1,24.1z M19.1,17.1c-0.8,0-1.7,0.3-2.3,0.9 c-0.6,0.6-1,1.4-1,2.2s0.3,1.7,0.9,2.3c0.6,0.6,1.4,0.9,2.2,0.9c0.8,0,1.7-0.3,2.3-0.9c0.6-0.6,0.9-1.4,0.9-2.3 c0-0.8-0.3-1.6-0.9-2.2C20.7,17.4,20,17.1,19.1,17.1L19.1,17.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.05bd173b32a2b437f0b288de5f49af8f.svg";
export { ForwardRef as ReactComponent };